export const offerings = [
  {
    id: 'noetivra',
    tag: 'Interactive workspace · Coming soon',
    title: 'Noetivra',
    body: 'Bring knowledge, capability profiles, development plans and institutional workflows together in one intuitive workspace.',
    example: '',
    link: '/noetivra',
    linkLabel: 'Explore Noetivra',
  },
  {
    id: 'semantic-knowledge',
    tag: 'Knowledge infrastructure',
    title: 'Semantic Knowledge Platform',
    body: 'Turn information into connected, inspectable knowledge—with evidence, context, relationships and provenance.',
    example:
      'A research organization, for example, could use the platform to connect studies, researchers, institutions, publications, and findings—making it easier to trace a claim back to its sources and discover related evidence.',
    link: '/semantic-knowledge',
    linkLabel: 'Explore the Semantic Knowledge Platform',
  },
  {
    id: 'human-capability',
    tag: 'Assessment & development framework · CJI · NCJI',
    title: 'Human Capability Framework',
    body: 'Develop reasoning, judgment and readiness for responsibility through structured assessment, feedback and purposeful practice.',
    example: '',
    link: '/human-capability',
    linkLabel: 'Explore the Human Capability Framework',
  },
  {
    id: 'institutional-intelligence',
    tag: 'Capability + connected knowledge',
    title: 'Institutional intelligence',
    body: 'We bring capability frameworks and connected knowledge together to help organizations identify gaps, understand complex problems, design practical responses, and learn from results.',
    example: '',
    link: '/solutions',
    linkLabel: 'See solutions by sector',
  },
]

export const judgmentSteps = [
  {
    title: 'Connect the evidence',
    body: 'Bring research, records, and expertise into a structured system where relationships and sources remain visible.',
  },
  {
    title: 'Develop capability',
    body: 'Help people strengthen the reasoning and judgment needed to interpret information and navigate difficult choices.',
  },
  {
    title: 'Support action',
    body: 'Give teams clearer ways to evaluate options, coordinate work, and review outcomes over time.',
  },
]

export const humanCapabilityProducts = [
  {
    acronym: 'CJI',
    name: 'Civic Judgment Index',
    body: 'A framework for examining the quality of reasoning and judgment in civic and social contexts.',
    link: '/cji',
  },
  {
    acronym: 'NCJI',
    name: 'Neurocognitive Civic Judgment Index',
    body: 'A broader developmental framework connecting human capability, civic resilience, institutional readiness, and leadership responsibility.',
    link: '/ncji',
  },
]

export const audiences = [
  { label: 'Research organizations', link: '/semantic-knowledge' },
  { label: 'Educators', link: '/education' },
  { label: 'Civil society groups', link: '/civil-society' },
  { label: 'Employers', link: '/employers' },
  { label: 'Public institutions', link: '/government' },
]
